import { render } from "./ProjectSummary.vue?vue&type=template&id=d881285e"
import script from "./ProjectSummary.vue?vue&type=script&lang=js"
export * from "./ProjectSummary.vue?vue&type=script&lang=js"

import "./ProjectSummary.vue?vue&type=style&index=0&id=d881285e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__